import React, { useState, useRef, useEffect } from 'react';
import { MoreHorizontal } from 'lucide-react';

const ActionMenu = ({
  children,
  trigger,
  align = 'left',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`relative ${className}`} ref={menuRef}>
      {trigger ? (
        <div onClick={() => setIsOpen(!isOpen)}>
          {trigger}
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          title="المزيد من الخيارات"
        >
          <MoreHorizontal size={20} />
        </button>
      )}

      {isOpen && (
        <div
          className={`absolute z-50 mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-200 py-2 animate-scaleIn ${
            align === 'right' ? 'end-0' : 'start-0'
          }`}
        >
          {React.Children.map(children, (child) => {
            if (!child) return null;
            return React.cloneElement(child, {
              onClick: (e) => {
                if (child.props.onClick) {
                  child.props.onClick(e);
                }
                setIsOpen(false);
              }
            });
          })}
        </div>
      )}
    </div>
  );
};

export const ActionMenuItem = ({
  icon: Icon,
  children,
  onClick,
  variant = 'default',
  loading = false,
  disabled = false
}) => {
  const variantClasses = {
    default: 'text-gray-700 hover:bg-gray-50 hover:text-gray-900',
    danger: 'text-red-600 hover:bg-red-50 hover:text-red-700',
    success: 'text-green-600 hover:bg-green-50 hover:text-green-700',
    primary: 'text-blue-600 hover:bg-blue-50 hover:text-blue-700',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${variantClasses[variant]}`}
    >
      {loading ? (
        <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : Icon ? (
        <Icon size={16} />
      ) : null}
      <span>{children}</span>
    </button>
  );
};

export default ActionMenu;
